import { type DiningOption } from "~/stores/kiosk-session/types";

export type ProductsKeysListArgs = {
  userIdentifierValue: string | null;
  diningOption: DiningOption | null;

  /**
   * This is used to differentiate between the identify and display modes:
   * - identify: when the user is identified (e.g. when scanning a card)
   * - display: when the user is displayed (e.g. when displaying user + products)
   */
  mode: "identify" | "display";
};

export const productsKeys = {
  all: ["products"] as const,
  lists: () => [...productsKeys.all, "list"] as const,
  listsByUserIdentifier: (userIdentifier: string | null) =>
    [...productsKeys.lists(), userIdentifier ?? "no_customer"] as const,
  list: ({ userIdentifierValue, diningOption, mode }: ProductsKeysListArgs) =>
    [
      ...productsKeys.listsByUserIdentifier(userIdentifierValue),
      diningOption,
      mode
    ] as const
};
